/*
export const API_URL = "http://localhost:12033/api/";
export const SESSION_COOKIE = "userLocalADminSupermaNLovedrip";
//export const MIGRATION_DOMAIN = "https://lovedripptestapp.tsdevcut.co.za/wp-json/ts/migration/list/v1/";
*/

export const API_URL = "https://lovedripp-api.onrender.com/api/";
export const SESSION_COOKIE = "userLiveLiverpoolLovetoDripedBackend";
export const MIGRATION_DOMAIN = "https://loved.tsdevcut.co.za/wp-json/ts/migration/list/v1/";
